import React, { useState, useEffect } from "react";

const AlertMessage = ({ message, type = "info", onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 10); // activa la animación
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose && onClose(), 300); // espera el fade-out
  };

  const bgColor = {
    success: "alert-success",
    error: "alert-danger",
    info: "alert-info",
    warning: "alert-warning"
  };

  return (
    <div
      className={`alert ${bgColor[type]} d-flex justify-content-between align-items-start small py-2 px-3 mt-2`}
      role="alert"
      style={{
        position: "relative",
        borderRadius: "0.5rem",
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(-10px)",
        transition: "opacity 0.3s ease, transform 0.3s ease"
      }}
    >
      <span className="flex-grow-1" style={{ paddingRight: "2rem" }}>{message}</span>

      {onClose && (
        <button
          onClick={handleClose}
          type="button"
          aria-label="Close"
          style={{
            position: "absolute",
            top: "0.5rem",
            right: "2px",
            background: "transparent",
            border: "none",
            fontWeight: "bold",
            fontSize: "1.4rem",
            lineHeight: 0,
            color: "#333",
            cursor: "pointer"
          }}
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default AlertMessage;